(function () {
    'use strict';

    angular
        .module('core.filters')
        .filter('cep', FormatCEP)

    function FormatCEP() {
        return input => {
            let string = input + '';

            if (string.length == 11)
                return string.replace(/(\d{5})(\d{3})/g, '$1.$2-$4');

            return string;
        }
    }
}());